import { render, staticRenderFns } from "./lookmodel.vue?vue&type=template&id=5f8f1b55"
import script from "./lookmodel.vue?vue&type=script&lang=js"
export * from "./lookmodel.vue?vue&type=script&lang=js"
import style0 from "./lookmodel.vue?vue&type=style&index=0&id=5f8f1b55&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports